import { FormattedMessage as FM } from "react-intl";

function ListFieldTitle({ field }) {
  return (
    <span className="mb-1 block text-sm text-neutral-500">
      <FM id={field.label} />
      {field.required && " *"}
    </span>
  );
}

export default ListFieldTitle;
